var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeavySnowShower01 = function SvgHeavySnowShower01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 12.3,
    y1: 154.8,
    x2: 153.52,
    y2: 13.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 53.88,
    y1: 196.37,
    x2: 195.09,
    y2: 55.16,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 38.19,
    y1: 180.68,
    x2: 179.4,
    y2: 39.47,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 24.15,
    y1: 166.65,
    x2: 165.37,
    y2: 25.43,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 48.48,
    y1: 190.97,
    x2: 189.69,
    y2: 49.76,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 82.57,
    y1: 225.07,
    x2: 223.79,
    y2: 83.85,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 66.73,
    y1: 209.22,
    x2: 207.95,
    y2: 68.01,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 83.19,
    y1: 225.68,
    x2: 224.4,
    y2: 84.47,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 19.92,
    y1: 162.42,
    x2: 161.14,
    y2: 21.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 71.31,
    y1: 213.8,
    x2: 212.53,
    y2: 72.59,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M144.96,24.83c-2.76,0-5.59.37-8.57,1.14C129.11,10.1,113.54,0,95.96,0,76.49,0,59.42,12.46,53.48,31.01c-.54,1.68.39,3.47,2.06,4.01,1.68.54,3.47-.39,4.01-2.06,5.09-15.89,19.72-26.58,36.41-26.58,14.83,0,27.99,8.4,34.35,21.65-4.38,2-7.41,4.95-9.26,7.31-1.09,1.38-.85,3.39.53,4.48.59.46,1.28.68,1.97.68.94,0,1.88-.42,2.51-1.21,1.73-2.19,4.76-5.08,9.39-6.41.02,0,.09-.02.11-.03,3.4-1.11,6.48-1.65,9.41-1.65,16.85,0,30.56,13.71,30.56,30.56s-13.71,30.56-30.56,30.56H47.5c-12.69,0-23.02-10.32-23.02-23.01s10.33-23.02,23.02-23.02c1.87,0,3.83.31,6.16.96,3.05.92,5.88,2.57,7.98,4.65.62.62,1.44.93,2.25.93s1.64-.31,2.26-.94c1.24-1.25,1.24-3.27-.01-4.51-2.83-2.81-6.61-5.03-10.66-6.25-.01,0-.02,0-.03,0,0,0-.02-.01-.03-.01-2.92-.82-5.44-1.2-7.92-1.2-16.21,0-29.39,13.19-29.39,29.39s13.19,29.39,29.39,29.39h97.47c20.37,0,36.93-16.57,36.93-36.93,0-20.37-16.57-36.94-36.93-36.94"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M141.58,119.29c-.59-1.02-1.9-1.37-2.92-.78l-5.94,3.43,1.24-4.64c.31-1.14-.37-2.31-1.51-2.62-1.14-.29-2.31.37-2.62,1.51l-2.35,8.77-4.57,2.64c-1.17-1.22-2.67-2.09-4.35-2.51v-5.19l6.42-6.42c.83-.83.83-2.19,0-3.02s-2.19-.83-3.02,0l-3.4,3.4v-6.95c0-1.18-.96-2.14-2.14-2.14s-2.14.96-2.14,2.14v6.93l-3.4-3.4c-.83-.83-2.19-.83-3.02,0-.83.83-.83,2.19,0,3.02l6.42,6.42v5.2c-1.69.41-3.19,1.29-4.36,2.51l-4.49-2.59-2.35-8.77c-.31-1.14-1.47-1.81-2.62-1.51-1.14.31-1.81,1.48-1.51,2.62l1.24,4.64-6.02-3.47c-1.02-.59-2.33-.24-2.92.78-.59,1.02-.24,2.33.78,2.92l6.01,3.47-4.64,1.24c-1.14.31-1.81,1.48-1.51,2.62.26.95,1.12,1.58,2.06,1.58.18,0,.37-.02.56-.07l8.77-2.35,4.52,2.61c-.23.8-.4,1.64-.4,2.51s.16,1.7.4,2.5l-4.5,2.6-8.77-2.35c-1.14-.29-2.31.37-2.62,1.51-.3,1.14.37,2.31,1.51,2.62l4.64,1.24-6.02,3.47c-1.02.59-1.37,1.9-.78,2.92.59,1.02,1.9,1.37,2.92.78l6.01-3.47-1.24,4.64c-.3,1.14.37,2.31,1.51,2.62,1.17.31,2.32-.39,2.62-1.51l2.35-8.77,4.49-2.59c1.17,1.22,2.67,2.1,4.36,2.51v5.26l-6.42,6.42c-.83.83-.83,2.19,0,3.02.83.83,2.19.83,3.02,0l3.4-3.4v6.87c0,1.18.96,2.14,2.14,2.14s2.14-.96,2.14-2.14v-6.86l3.4,3.4c.83.83,2.19.83,3.02,0,.83-.83.83-2.19,0-3.02l-6.42-6.42v-5.28c1.69-.42,3.19-1.29,4.36-2.51l4.55,2.63,2.35,8.77c.3,1.12,1.45,1.82,2.62,1.51,1.14-.31,1.81-1.48,1.51-2.62l-1.24-4.64,5.95,3.43c1.02.59,2.33.24,2.92-.78.59-1.02.24-2.33-.78-2.92l-5.94-3.43,4.64-1.24c1.14-.31,1.81-1.48,1.51-2.62-.3-1.14-1.47-1.81-2.62-1.51l-8.77,2.35-4.58-2.65c.23-.8.4-1.62.4-2.5s-.17-1.71-.4-2.51l4.57-2.64,8.77,2.35c.19.05.37.07.56.07.94,0,1.81-.63,2.06-1.58.3-1.14-.37-2.31-1.51-2.62l-4.65-1.24,5.95-3.43c1.02-.59,1.37-1.9.78-2.92M116.43,138.55c-2.61,0-4.73-2.12-4.73-4.73s2.12-4.74,4.73-4.74,4.75,2.13,4.75,4.74-2.13,4.73-4.75,4.73"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M61.67,157.2h0c-.73-.73-.73-1.92,0-2.66l11.09-11.09c.73-.73,1.92-.73,2.66,0,.73.73.73,1.92,0,2.66l-11.09,11.09c-.73.73-1.92.73-2.66,0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32.37,158.43h0c-.73-.73-.73-1.92,0-2.66l11.09-11.09c.73-.73,1.92-.73,2.66,0,.73.73.73,1.92,0,2.66l-11.09,11.09c-.73.73-1.92.73-2.66,0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M58.55,180.9h0c-.73-.73-.73-1.92,0-2.66l11.09-11.09c.73-.73,1.92-.73,2.66,0s.73,1.92,0,2.66l-11.09,11.09c-.73.73-1.92.73-2.66,0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M124.48,183.17h0c-.73-.73-.73-1.92,0-2.66l11.09-11.09c.73-.73,1.92-.73,2.66,0,.73.73.73,1.92,0,2.66l-11.09,11.09c-.73.73-1.92.73-2.66,0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M153.88,122.08h0c-.73-.73-.73-1.92,0-2.66l11.09-11.09c.73-.73,1.92-.73,2.66,0,.73.73.73,1.92,0,2.66l-11.09,11.09c-.73.73-1.92.73-2.66,0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M153.88,154.99h0c-.73-.73-.73-1.92,0-2.66l11.09-11.09c.73-.73,1.92-.73,2.66,0,.73.73.73,1.92,0,2.66l-11.09,11.09c-.73.73-1.92.73-2.66,0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M58.44,138.14c1.34,0,2.43-1.09,2.43-2.43v-8.52l8.53,4.92c1.16.67,2.65.27,3.32-.89.67-1.16.27-2.65-.89-3.32l-8.53-4.92,7.38-4.26c1.16-.67,1.56-2.16.89-3.32-.67-1.16-2.16-1.56-3.32-.89l-7.38,4.26v-9.85c0-1.34-1.09-2.43-2.43-2.43s-2.43,1.09-2.43,2.43v9.85l-7.38-4.26c-1.16-.67-2.65-.27-3.32.89-.67,1.16-.27,2.65.89,3.32l7.38,4.26-8.53,4.92c-1.16.67-1.56,2.16-.89,3.32.67,1.16,2.16,1.56,3.32.89l8.53-4.92v8.52c0,1.34,1.09,2.43,2.43,2.43Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M99.36,200c1.34,0,2.43-1.09,2.43-2.43v-8.52l8.53,4.92c1.16.67,2.65.27,3.32-.89.67-1.16.27-2.65-.89-3.32l-8.53-4.92,7.38-4.26c1.16-.67,1.56-2.16.89-3.32-.67-1.16-2.16-1.56-3.32-.89l-7.38,4.26v-9.85c0-1.34-1.09-2.43-2.43-2.43s-2.43,1.09-2.43,2.43v9.85l-7.38-4.26c-1.16-.67-2.65-.27-3.32.89-.67,1.16-.27,2.65.89,3.32l7.38,4.26-8.53,4.92c-1.16.67-1.56,2.16-.89,3.32.67,1.16,2.16,1.56,3.32.89l8.53-4.92v8.52c0,1.34,1.09,2.43,2.43,2.43Z"
  })));
};
export default SvgHeavySnowShower01;